import { DEFAULT_ROOM_SETTINGS, type RoomSettings, roomSettingsSchema } from '@xox/shared'
import { persisted } from '../lib/storage'
import { SettingsFieldset, type SettingsFormProps } from './TurnSecondsField'
import { Switch } from './ui'

const storage = persisted('xox-room-settings', roomSettingsSchema, DEFAULT_ROOM_SETTINGS)

/** Last settings this device created an XOX room with, so the form remembers them. */
export const loadRoomSettings = storage.load
export const saveRoomSettings = storage.save

/** Short human summary, shown inside the room so the opponent knows the rules too. */
export function describeSettings(s: RoomSettings): string {
  return `${s.turnSeconds} seconds per turn · ${s.showVanishHint ? 'next-to-vanish mark is faded' : 'no fading hint'}`
}

export function RoomSettingsForm(props: SettingsFormProps<RoomSettings>) {
  const { value, onChange, disabled } = props
  return (
    <SettingsFieldset {...props}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div id="vanish-hint-label" className="text-sm font-medium">
            Show which mark disappears next
          </div>
          <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
            {value.showVanishHint
              ? 'Your oldest mark is faded so you can see which one will vanish on your next move.'
              : 'Hard mode: all marks look the same, so players must remember their oldest one.'}
          </p>
        </div>
        <Switch
          aria-labelledby="vanish-hint-label"
          checked={value.showVanishHint}
          disabled={disabled}
          onChange={(showVanishHint) => onChange({ ...value, showVanishHint })}
        />
      </div>
    </SettingsFieldset>
  )
}
